import { render, staticRenderFns } from "./videoHighlightsExtraction.vue?vue&type=template&id=df99a674&scoped=true&"
import script from "./videoHighlightsExtraction.vue?vue&type=script&lang=js&"
export * from "./videoHighlightsExtraction.vue?vue&type=script&lang=js&"
import style0 from "./videoHighlightsExtraction.vue?vue&type=style&index=0&id=df99a674&prod&lang=scss&scoped=true&"
import style1 from "./videoHighlightsExtraction.vue?vue&type=style&index=1&id=df99a674&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df99a674",
  null
  
)

export default component.exports